<template>
  <a-modal 
    :visible="visible" 
    :title="title" 
    :width="750"
    @cancel="onCancel"
    @ok="onSave"
    cancelText="取消" okText="确认">
    <a-form :form="edit_item">
      <a-row :gutter="10">
        <a-col :span="8">
          <a-form-item label="个体分组名称">
            <a-input v-model="edit_item.name" class="width-100"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: "farmCellEdit",
  components: {
  },
  data() {
    return {
      action: '',
      edit_item: {},
      edit_item_template: {
        name: '',
        farm_id: '',
        parent_id: ''
      },
      visible: false,
      title: ''
    }
  },
  methods: {
    open(action, farm, item, parent_id) {
      this.action = action
      this.edit_item = JSON.parse(JSON.stringify(this.edit_item_template))
      if (action == 'add') {
        this.title = parent_id == null ? '新增群' : '新增子群'
        this.edit_item.farm_id = farm.id
        this.edit_item.parent_id = parent_id
        this.edit_item.name = ''
        this.title = farm.name
      } else {
        this.title = '编辑群'
        this.edit_item = item
      }
      this.visible = true
    },
    onCancel() {
      this.visible = false
    },
    onSave() {
      if (this.action == 'add') {
        this.$api.post_farm_cell(this.edit_item).then(res =>  {
          if (res.code == 200) {
            this.$message.success("保存成功");
            this.visible = false
            this.edit_item = JSON.parse(JSON.stringify(this.edit_item_template))
            this.$emit('finish-edit')
          }
        })
      } else {
        this.$api.put_farm_cell(this.edit_item).then(res =>  {
          if (res.code == 200) {
            this.$message.success("保存成功");
            this.visible = false
            this.edit_item = JSON.parse(JSON.stringify(this.edit_item_template))
            this.$emit('finish-edit')
          }
        })
      }
    },
    on_farm_select(farm_id) {
      this.edit_item.farm_id = farm_id
    },
  },
}
</script>

<style>
</style>